export const capitalizeFirstLetter = (str: string) => {
  const lowercaseString = str.toLowerCase()

  return lowercaseString.charAt(0).toUpperCase() + lowercaseString.slice(1)
}
